const empty = () =>
    import ( /* webpackChunkName: "empty" */ '../views/Empty.vue');

export default [{
    path: 'book',
    name: 'BookModule',
    component: empty,
    children: [{
        path: 'book',
        name: 'Book',
        component: empty,
        children: [{
                path: 'manage',
                name: 'BookManage',
                component: () =>
                    import (
                        /* webpackChunkName: "book" */
                        '../views/book/BookManage.vue'
                    ),
                meta: {
                    title: '图书管理',
                    root: true,
                },
            },
            {
                path: 'edit',
                name: 'BookEdit',
                component: () =>
                    import (
                        /* webpackChunkName: "book" */
                        '../views/book/BookEdit.vue'
                    ),
                meta: {
                    title: '图书新增/编辑',
                },
            },
            {
                path: 'catagory',
                name: 'BookCatagory',
                component: () =>
                    import (
                        /* webpackChunkName: "book" */
                        '../views/book/BookCatagory.vue'
                    ),
                meta: {
                    title: '图书分类',
                    root: true,
                },
            },
        ]
    }, ],
}, ];